import { lazy } from "react";

const AddTour = lazy(() => import("../pages/AddTour"));
const ViewTours = lazy(() => import("../pages/ViewTours"));

const masterRoutes = [
  {
    id: 1,
    role: "admin",
    path: "/",
    element: <AddTour />,
  },
  {
    id: 2,
    role: "admin",
    path: "/planned-tours",
    element: <ViewTours />,
  },
];

export default masterRoutes;
